import React, { Component } from 'react'

export default class Emoji extends Component {
  render() {
    return (
      <div>
        Emoji
      </div>
    )
  }
}
